<template>
  <public-page />
  <div class="organizationalStructure">
    <div class="titleName">组织架构</div>
    <img src="../../assets/images/pages/about/zzjg.png" alt="组织架构" class="mainContainer">
  </div>
</template>

<script setup>
import PublicPage from "./components/publicPage";

// 设置TDK
useHead({
  title: '组织架构|关于我们 - 郑州路桥建设投资集团有限公司',
})
</script>

<style scoped lang="scss">
.organizationalStructure {
  background: url("../../assets/images/pages/about/zzjgbj.png") no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 1100px;
  margin-top: 20px;
  .titleName {
    text-align: center;
    font-size: 28px;
    line-height: 50px;
    color: var(--block-title-color);
    display: block;
    position: relative;
    margin-bottom: 70px;
    &:after {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 6px;
      content: "";
      display: block;
      width: 145px;
      height: 11px;
      opacity: 0.7;
      background: var(--main-blue-color);
    }
  }
  img {
    //width: var(--body-min-width);
    display: block;
  }
}
</style>